// Working ⇄ declaration unit conversion; the math lives in iscc-backend.
import { baseApi } from './baseApi';
import { processServerError } from './listQuery';
import { buildUnitConversionPayload, processUnitConversion } from '@/lib/mappers';

const PATHS = { convert: '/units/convert' };

export const unitsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // A POST that only computes, so it's a query: identical inputs are served from cache.
    convertUnits: build.query({
      query: (args) => ({
        url: PATHS.convert,
        method: 'POST',
        body: buildUnitConversionPayload(args),
      }),
      transformResponse: processUnitConversion,
      transformErrorResponse: processServerError,
    }),
  }),
});

export const { useConvertUnitsQuery, useLazyConvertUnitsQuery } = unitsApi;
